import Model from './model.js'
// import {RequestinProcess} from '../helper/request.action.js'

// READ
export default {
  Search: function(params) {
      Model.Search(params)
  }
}


// WEBPACK FOOTER //
// ./src/App/component/helper/presenter.js